import { render, staticRenderFns } from "./WaterMeterDashboard.vue?vue&type=template&id=27ad847a&scoped=true"
import script from "./WaterMeterDashboard.vue?vue&type=script&lang=js"
export * from "./WaterMeterDashboard.vue?vue&type=script&lang=js"
import style0 from "./WaterMeterDashboard.vue?vue&type=style&index=0&id=27ad847a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ad847a",
  null
  
)

export default component.exports